import { render, staticRenderFns } from "./WarningArea.vue?vue&type=template&id=71b0f0d6"
import script from "./WarningArea.vue?vue&type=script&lang=js"
export * from "./WarningArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports